/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, breakpoints, useTheme } from '@coursera/cds-core';

import SocialProofPill from 'bundles/teams-v2/components/SocialProofPill';

type Props = {
  showSocialProofPill?: boolean;
};

const HeadingWithSocialProofPill: React.LegacyFunctionComponentWithChildren<Props> = ({
  showSocialProofPill,
  children,
}) => {
  const theme = useTheme();
  const styles = {
    socialProof: css`
      ${breakpoints.down('sm')} {
        padding-top: var(--cds-spacing-200);
      }

      ${breakpoints.up('md')} {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    `,
  };

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        {children}
      </Grid>
      <Grid item xs={12} md={6} css={styles.socialProof}>
        {showSocialProofPill && <SocialProofPill />}
      </Grid>
    </Grid>
  );
};

export default HeadingWithSocialProofPill;
